import {
  SET_SHOW_CALL_BACK_MODAL,
  SET_HIDE_CALL_BACK_MODAL,
} from "constants-lib/actionTypes"

export const setShowCallBackModal = () => (dispatch) =>
  dispatch({
    type: SET_SHOW_CALL_BACK_MODAL,
  })

export const setHideCallBackModal = () => (dispatch) =>
  dispatch({
    type: SET_HIDE_CALL_BACK_MODAL,
  })
